import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Input from "../../components/forms-fields/Input";
import { getAddStaffCarriedOverSchema } from "../../schemas";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    postRecords,
    catchAsync,
    isSuccess,
    toastSuccessMessages,
    toastErrorMessages,
} from "../../helper/helper";
import {
    PUT_STAFF_WORKLOADS_URL,
} from "../../env";

function AddCarriedOver({ viewStaffMemberData, subModalUpdateWorkLoad }) {
    // console.log("🚀 ~ AddCarriedOver ~ viewStaffMemberData:", viewStaffMemberData?.staffMember?.contractedHours?.contractedHours)
    const [staffMemberId, setStaffMemberId] = useState(viewStaffMemberData?.staffMember?._id)
    const [maxCarriedHour, setMaxCarriedHour] = useState(viewStaffMemberData?.staffMember?.contractedHours?.contractedHours)
    useEffect(() => {
        setStaffMemberId(viewStaffMemberData?.staffMember?._id)
        setMaxCarriedHour(viewStaffMemberData?.staffMember?.contractedHours?.contractedHours)
    }, [viewStaffMemberData])

    const handleShowHideModal = () => {
        subModalUpdateWorkLoad((prevShow) => !prevShow);
    };
    const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
    const [isToastAddCarriedHours, setIsToastAddCarriedHours] = useState(false);

    const [suFormData, setSuFormData] = useState({
        staffMember: staffMemberId,
        carriedOverHours: 0,
    });

    const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
    } = useFormik({
        initialValues: suFormData,
        validationSchema: getAddStaffCarriedOverSchema(maxCarriedHour),
        onSubmit: async (values) => {
            try {
                setIsSubmitButtonClicked(true);
                await postAddCarriedHoursFormData(values);
            } catch (error) {
                
            }
        },
    });

    const processPostRecords = (method, data) => {
        if (data?.status !== isSuccess) {
            setIsToastAddCarriedHours(true);
            toastErrorMessages(toast.error, data?.message, "", 1000, 1000);
            setIsSubmitButtonClicked(false);
            setTimeout(() => {
                handleShowHideModal();
                setIsToastAddCarriedHours(false)
            }, 3000);
        } else if (
            method === "postAddCarriedHoursFormData" &&
            data?.status === isSuccess
        ) {
            setIsToastAddCarriedHours(true);
            toastSuccessMessages(toast.success, data?.message, "", 500, 500);
            setIsSubmitButtonClicked(false);
            setTimeout(() => {
                handleShowHideModal();
                setIsToastAddCarriedHours(false)
            }, 2000);
        }
    };

    const postAddCarriedHoursFormData = catchAsync(async (req, res) => {
        const updatedValues = {
            ...values,
            carriedOverHours: values?.carriedOverHours,

        };
        // console.log("🚀 ~ postAddCarriedHoursFormData ~ values:", updatedValues)
        const response = await postRecords(PUT_STAFF_WORKLOADS_URL, updatedValues);
        processPostRecords("postAddCarriedHoursFormData", response);
        setIsSubmitButtonClicked(false);
    });

    return (
        <>
            <div className="incidents consentCapacityAddNew">
                <form onSubmit={handleSubmit}>
                    <div className="formBlockContent">
                        <div className="row">
                            <div className="col-sm-12 col-md-12">
                                <Input
                                    type="number"
                                    id=""
                                    name="carriedOverHours"
                                    value={values?.carriedOverHours}
                                    onChange={(e) => setFieldValue("carriedOverHours", e.target.value)}
                                    onBlur={handleBlur}
                                    max={maxCarriedHour}
                                    labelText="Carried Hours"
                                    required={true}
                                    customError={touched?.carriedOverHours && errors?.carriedOverHours}
                                    errorMessage={errors?.carriedOverHours}
                                    errorClass={
                                        touched?.carriedOverHours && errors?.carriedOverHours
                                            ? "validationError"
                                            : ""
                                    }

                                />
                            </div>
                        </div>
                    </div>

                    <div className="formActionButtons">
                        <span
                            onClick={subModalUpdateWorkLoad}
                            className="btn btn-sm btn-outline-primary"
                        >
                            Close
                        </span>
                        {isSubmitButtonClicked ? (
                            <Button
                                onClick={subModalUpdateWorkLoad}
                                className="btn-sm"
                                variant="primary"
                                disabled
                            >
                                Loading...
                            </Button>
                        ) : (
                            <Button className="btn-sm" variant="primary" type="submit">
                                Save
                            </Button>
                        )}
                    </div>
                </form>
            </div>
            {isToastAddCarriedHours && <ToastContainer />}
        </>
    );
}

export default AddCarriedOver;